import { getFormInputProps } from "util/forms";
import OnboardingForm from "ui/forms/ECommerce/Onboarding/OnboardingForm";
import { InputableRadioGroup } from "ui/molecules/Input";
import { OnboardingInputControl } from "ui/molecules/Input";
import { FormField, type OnboardingMediaAndComplianceCheckProps } from "./types";

const MediaAndComplianceCheck = ({
    values,
    isSubmitting,
    isValid,
    isIncomplete,
    requestedChangeFields,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingMediaAndComplianceCheckProps) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        isIncomplete={isIncomplete}
        requestedChangeFields={requestedChangeFields}
        handleSubmit={handleSubmit}
    >
        <OnboardingInputControl
            name={FormField.AdverseMediaCoverageInput}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            renderInput={({ disabled }) => (
                <InputableRadioGroup
                    slotProps={{
                        typography: {
                            children: 'Has the company or its leadership been subject to adverse media coverage?*'
                        },
                        formControlLabel: {
                            disabled
                        },
                        radioGroup: {
                            'aria-labelledby': FormField.HasAdverseMediaCoverage,
                            name: FormField.HasAdverseMediaCoverage,
                            value: values[FormField.HasAdverseMediaCoverage],
                            onChange: handleChange,
                            onBlur: handleBlur
                        },
                        textField: {
                            ...getFormInputProps(FormField.AdverseMediaCoverageInput, form),
                            disabled,
                            name: FormField.AdverseMediaCoverageInput,
                            value: values[FormField.AdverseMediaCoverageInput],
                            label: 'IF YES, please provide details and sources',
                            onChange: handleChange,
                            onBlur: handleBlur
                        }
                    }}
                />
            )}
        />
        <OnboardingInputControl
            name={FormField.LegalInvestigationInput}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            renderInput={({ disabled }) => (
                <InputableRadioGroup
                    slotProps={{
                        typography: {
                            sx: {
                                mt: 2
                            },
                            children: 'Is the company or its leadership subject to legal investigations or enforcement actions?*'
                        },
                        formControlLabel: {
                            disabled
                        },
                        radioGroup: {
                            'aria-labelledby': FormField.HasLegalInvestigation,
                            name: FormField.HasLegalInvestigation,
                            value: values[FormField.HasLegalInvestigation],
                            onChange: handleChange,
                            onBlur: handleBlur
                        },
                        textField: {
                            ...getFormInputProps(FormField.LegalInvestigationInput, form),
                            disabled,
                            name: FormField.LegalInvestigationInput,
                            value: values[FormField.LegalInvestigationInput],
                            label: 'IF YES, please provide details',
                            onChange: handleChange,
                            onBlur: handleBlur
                        }
                    }}
                />
            )}
        />
        <OnboardingInputControl
            name={FormField.HasCertification}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            renderInput={({ disabled }) => (
                <InputableRadioGroup
                    slotProps={{
                        typography: {
                            sx: {
                                mt: 2
                            },
                            children: 'Does your business have certifications? (ISO, PCI DSS, etc.)*'
                        },
                        formControlLabel: {
                            disabled
                        },
                        radioGroup: {
                            'aria-labelledby': FormField.HasCertification,
                            name: FormField.HasCertification,
                            value: values[FormField.HasCertification],
                            onChange: handleChange,
                            onBlur: handleBlur
                        }
                    }}
                    slots={{
                        textField: <></>
                    }}
                />
            )}
        />
        <OnboardingInputControl
            name={FormField.IsCompliantWithTax}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            renderInput={({ disabled }) => (
                <InputableRadioGroup
                    slotProps={{
                        typography: {
                            sx: {
                                mt: 2
                            },
                            children: 'Are you compliant with local tax regulations?*'
                        },
                        formControlLabel: {
                            disabled
                        },
                        radioGroup: {
                            'aria-labelledby': FormField.IsCompliantWithTax,
                            name: FormField.IsCompliantWithTax,
                            value: values[FormField.IsCompliantWithTax],
                            onChange: handleChange,
                            onBlur: handleBlur
                        }
                    }}
                    slots={{
                        textField: <></>
                    }}
                />
            )}
        />
        <OnboardingInputControl
            name={FormField.RegisteredWithAuthorityInput}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            renderInput={({ disabled }) => (
                <InputableRadioGroup
                    slotProps={{
                        typography: {
                            sx: {
                                mt: 2
                            },
                            children: 'Are you registered with any financial or regulatory authority?*'
                        },
                        formControlLabel: {
                            disabled
                        },
                        radioGroup: {
                            'aria-labelledby': FormField.IsRegisteredWithAuthority,
                            name: FormField.IsRegisteredWithAuthority,
                            value: values[FormField.IsRegisteredWithAuthority],
                            onChange: handleChange,
                            onBlur: handleBlur
                        },
                        textField: {
                            ...getFormInputProps(FormField.RegisteredWithAuthorityInput, form),
                            disabled,
                            name: FormField.RegisteredWithAuthorityInput,
                            value: values[FormField.RegisteredWithAuthorityInput],
                            label: 'IF YES, please provide details',
                            onChange: handleChange,
                            onBlur: handleBlur
                        }
                    }}
                />
            )}
        />
    </OnboardingForm>
);

export default MediaAndComplianceCheck;
